/*
  <H3
    color={color} 
    size={size} 
    className={className}
  />
  - - - - - - - - - - - - -
  color -> white / black
  size -> xl / lg / md / sm / xs
  className -> css classes
  - - - - - - - - - - - - -
*/

export default function H3({
  color,
  className,
  desktopSize,
  mobileSize,
  children,
  ...props
}) {
  return (
    <h3
      className={`title tc-${color} title--${desktopSize}-d title--${mobileSize} ${className}`}
      {...props}
    >
      {children}
    </h3>
  );
}

H3.defaultProps = {
  color: "black",
  desktopSize: "md",
  mobileSize: "sm",
  className: "",
};
